import React, { useCallback, useEffect, useState } from "react";
import {
  BarSection,
  CashSection,
  CoinSection,
  GinniSection,
  GoldRateWorkSection,
  LabSection,
  PCSection,
  SilverRateWorkSection,
  SilverSection,
} from "./TransactionSection";
import { useBrands } from "../../context/BrandsContext";
import { getRequiredBrands } from "../../utils/brandsFilter";
import {
  cashInit,
  pcInit,
  labInit,
  barInit,
  ginniInit,
  coinInit,
  silverInit,
  silverRWInit,
  goldRWInit,
  sideTx,
} from "./components/Init";
import { errorAlert } from "../common/Swal";

const defaultValues = { transactions: [], paidAmounts: {} };

function TransactionTable({ type = "given", tx, setTx, seletectedCustomer }) {
  const isGiven = type === "given";
  const prefix = type;
  const heading = isGiven ? "Given" : "Received";

  const { brands, refreshBrands } = useBrands();

  const [pcBrands, setPcBrands] = useState([]);
  const [barBrands, setBarBrands] = useState([]);
  const [coinBrands, setCoinBrands] = useState([]);
  const [silverBrands, setSilverBrands] = useState([]);

  useEffect(() => {
    const pcBrands = getRequiredBrands("pc", brands);
    const barBrands = getRequiredBrands("bar", brands);
    const coinBrands = getRequiredBrands("coin", brands);
    const silverBrands = getRequiredBrands("silver", brands);

    setPcBrands(pcBrands);
    setBarBrands(barBrands);
    setCoinBrands(coinBrands);
    setSilverBrands(silverBrands);
  }, [brands]);

  const set = useCallback(
    (section) => (valueOrUpdater) => {
      setTx((prev) => {
        const next = {
          ...prev,
          [section]:
            typeof valueOrUpdater === "function"
              ? valueOrUpdater(prev[section])
              : valueOrUpdater,
        };
        return next;
      });
    },
    [type],
  ); // only recreates if type changes

  return (
    <div className="box">
      <h2>{heading}</h2>

      <CashSection prefix={prefix} state={tx.cash} setState={set("cash")} />
      <PCSection
        prefix={prefix}
        state={tx.pc}
        setState={set("pc")}
        brands={pcBrands}
        setBrands={setPcBrands}
        isGiven={isGiven}
        refreshBrands={refreshBrands}
      />
      <LabSection
        prefix={prefix}
        state={tx.lab}
        setState={set("lab")}
        isGiven={isGiven}
        handleReportSubmit={(transaction) => {
          if (!isCustomerSelected(seletectedCustomer?.customer)) {
            return errorAlert("Please Select the customer");
          }

          const addLab = { ...seletectedCustomer, lab: transaction };

          if (!checkCompleteField(addLab.lab)) {
            return errorAlert("Please, fill all the required fields.");
          }

          const queryData = encodeURIComponent(JSON.stringify(addLab));
          window.open(
            `/salepoint/gold-test-report?data=${queryData}`,
            "_blank",
          );
        }}
      />
      <BarSection
        prefix={prefix}
        state={tx.bar}
        setState={set("bar")}
        brands={barBrands}
        isGiven={isGiven}
        refreshBrands={refreshBrands}
      />
      <CoinSection
        prefix={prefix}
        state={tx.coin}
        setState={set("coin")}
        isGiven={isGiven}
        brands={coinBrands}
        refreshBrands={refreshBrands}
      />
      <GinniSection
        prefix={prefix}
        state={tx.ginni}
        setState={set("ginni")}
        isGiven={isGiven}
        onReportView={(transaction) => {
          const ginni = transaction;
          if (!isCustomerSelected(seletectedCustomer?.customer)) {
            return errorAlert("Please Select the customer");
          }
          if (!ginni.report || !ginni?.weight) {
            return errorAlert(
              "Please select the required fields to view the report.",
            );
          }

          const queryData = {
            ...seletectedCustomer,
            lab: {
              report: ginni.report,
              pureWeight: ginni.pureWeight,
              weight: ginni.weight,
            },
          };

          window.open(
            `/salepoint/gold-test-report?data=${encodeURIComponent(JSON.stringify(queryData))}`,
            "_blank",
          );

          // console.log(`${prefix} Ginni Report`, state);
        }}
        refineChargesFromSetting={
          seletectedCustomer?.customer?.setting?.refineCharges
        }
      />
      <SilverSection
        prefix={prefix}
        state={tx.silver}
        setState={set("silver")}
        brands={silverBrands}
        refreshBrands={refreshBrands}
      />
      {/* <GoldRateWorkSection
        prefix={prefix}
        state={goldRW}
        setState={setGoldRW}
      />
      <SilverRateWorkSection
        prefix={prefix}
        state={silverRW}
        setState={setSilverRW}
      /> */}

      {/* <div className="text-end mt-3">
        <button className="btn btn-primary" onClick={handleSubmit}>
          Save {heading}
        </button>
      </div> */}
    </div>
  );
}

// ─── Root TransactionTable ────────────────────────────────────────────────────

export default TransactionTable;

const checkCompleteField = (lab) => {
  return lab.report && lab.weight && lab.pureWeight;
};

export const isCustomerSelected = (customer) => {
  return customer && customer.customerId;
};
